export const SLUG_CASE_STUDIES = 'case-studies';
export const SLUG_REVIEWS = 'reviews';
export const SLUG_PHOTOS = 'photos';
